import client from '@/api/client';
import { gql } from '@apollo/client';
import fragments from '@/gql-fragments/course';

const getCoursesList = () => client
  .query({
    query: gql`
      query {
        getCoursesList {
          ...Course
          category {
            id
          }
          englishLevel {
            title
          }
          images {
            path
            size
          }
        }
        getCourseCategories {
          id
          title
          priority
        }
      }
      ${fragments.Course}
    `,
  });

export default {
  getCoursesList,
};
